import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { WorkflowLayout } from 'Components/ComponentLibrary/Organisms/WorkflowLayout/WorkflowLayout';
import { HeadlineTextMedium } from 'Packages/FacetDesign/Components';
import {
  _stringMetaFieldShowRemainingCharacters,
} from 'Components/UI/Meta/MetaControl/Types/String';
import { Layout } from './Layout';

const overrideSet = buildFacetDesignOverride()
  .nameOverride('justification', {
    [_stringMetaFieldShowRemainingCharacters]: true,
  }, overrideReadOnly)
  .nameOverride('title', {
    _component: () => HeadlineTextMedium,
  }, overrideReadOnly);
  // .nameOverride('description', {
  //   _component: () => BodyTextMedium,
  // }, overrideReadOnly);

export const HouseholdAccessJustificationPageTemplate = () => {
  const { pageContentResource } = usePageContentContext();

  return (
    <WorkflowLayout appearance={'elevated'}>
      <MetaResourceRenderer
        resource={pageContentResource}
        layout={Layout}
        metaOverrideSet={overrideSet}
      />
    </WorkflowLayout>
  );
};
